<template>
  <div class="timerRing">
    <svg class="timerRing timerCanvas" :class="[statusClass, jangle]" viewBox="0 0 232 232" preserveAspectRatio="xMidYMid meet" pointer-events="none">
      <circle class="track" r="106" cx="116" cy="116" transform="rotate(-90 116 116)" />
      <circle ref="bar" class="bar" r="106" cx="116" cy="116" transform="rotate(-90 116 116)" :style="{ strokeDasharray: c, strokeDashoffset: dash }" />
      <circle class="overdueRing" r="106" cy="116" cx="116" />
    </svg>
    <svg
      class="timerCanvas markerCanvas"
      :class="[setting ? 'setting' : 'running']"
      ref="marker"
      viewBox="0 0 232 232"
      preserveAspectRatio="xMidYMid meet"
      pointer-events="none"
      :style="{ transform: markerRotation }"
    >
      <g class="marker" :class="pulseClass">
        <circle class="visibleDot" r="8" cx="116" cy="10" />
        <circle class="invisibleDot" r="8" cx="116" cy="10" />
        <circle class="invisibleDot" r="8" cx="116" cy="222" />
      </g>
    </svg>

    <timer-setter v-if="phaseStore.settingUp" class="timerSetter" :type="props.type" />
  </div>
</template>
<script setup>
import { computed } from 'vue';
import { useTimeDisplay } from '@/composables/useTimeDisplay';
import TimerSetter from '@/components/TimerSetter.vue';
import { usePhaseStore } from '@/store/pinia/phase';
const phaseStore = usePhaseStore();
const props = defineProps({
  type: {
    default: 'phase',
  },
});
const { c, dash, statusClass, jangle, tickMs, barEasing, setting, prop } = useTimeDisplay({ r: 106, type: props.type });

const pulseClass = computed(() => {
  return false;
  // if (props.type === 'meetingSetter' && meetingTimeEdited.value) {
  //   return '';
  // } else if (props.type === 'phase' && setupTimeEdited.value) {
  //   return '';
  // } else {
  //   return !timerUpdated.value && !hasInteractedWithTimer.value[props.type] ? 'pulse' : '';
  // }
});

const markerRotation = computed(() => {
  let turn = prop.value;
  return `rotate(${turn}turn)`;
});
</script>
<style scoped lang="scss">
.timerRing {
  // --timer-bar: var(--c__time-base);
  // --timer-unit: var(--c__text);
  // --timer-minutes: var(--c__text);
  // --timer-seconds: var(--c__text);

  display: block;
  width: rem(232px);
  height: rem(232px);
  border-radius: 50%;
  position: relative;

  .timerCanvas {
    position: absolute;
    width: rem(232px);
    height: rem(232px);
    top: 0;
    display: block;
    overflow: visible;
  }

  .track,
  .bar {
    fill: none;
  }

  .track {
    stroke: var(--c__timer-track);
    stroke-width: 2;
    transition: stroke 250ms 0.2s, opacity 150ms, r 250ms;
  }

  .bar {
    stroke-width: 6;
    stroke: var(--timer-bar);
    transition: all v-bind(tickMs) v-bind(barEasing);
  }

  .setting .bar {
    transition: stroke 250ms 0.2s, opacity 150ms, r 250ms;
  }

  .overdueRing {
    stroke-width: 0;
    stroke: var(--c__warn);
    opacity: 0;
    fill: none;
    transition: stroke 0.2s ease 0.2s, opacity 0.2s ease 0.2s, r 0.4s ease-out, stroke-width 0.4s ease-out;
  }

  .jangle,
  .overdue {
    animation: overdue-jitter 2s linear 0s infinite;
  }

  .overdue {
    .bar,
    .track {
      opacity: 0;
    }

    .overdueRing {
      r: (106 - 9);
      stroke-width: 20;
      opacity: 1;
    }
  }

  .mid {
    --timer-bar: var(--c__time-mid);
  }

  .end {
    --timer-bar: var(--c__time-over);
  }

  // Markers

  .markerCanvas {
    transition: all v-bind(tickMs) v-bind(barEasing);
  }

  .marker {
    transform-origin: center;
    transform: rotateZ(0deg);
    rotate: 0;
  }

  .visibleDot {
    fill: var(--timer-bar);
    transform-origin: center;
    r: 1;
    opacity: 0;
    transition: r 400ms ease, opacity 400ms ease;
  }

  .invisibleDot {
    opacity: 0;
  }

  .setting {
    .visibleDot {
      r: 8;
      opacity: 1;
    }

    .pulse .visibleDot {
      animation: blob-pulse 0.8s ease infinite alternate;
    }
  }

  .blink {
    animation: timerBlink 2s infinite 5s;
  }

  // circle {
  //   fill: none;
  // }
  // .bar {
  //   stroke: currentColor;
  //   transition: all v-bind(animationTick) v-bind(easing);
  // }
  // &.mid {
  //   color: var(--c__time-mid);
  // }
  // &.end {
  //   color: var(--c__time-over);
  // }
  // &.jangle .track,
  // &.overdue .track {
  //   animation: overdue-jitter 2s linear 0s infinite;
  //   fill: currentColor;
  // }
}
</style>
